import React, { useState, useEffect } from 'react';
import { LogOut, Rss, ArrowRight, Edit2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import AdminNav from '../components/AdminNav';
import { rssFeedService, authService } from '../services/api';

function AdminRSSFeed() {
  const navigate = useNavigate();
  const [rssId, setRssId] = useState(null);
  const [rss, setRss] = useState({ title: '', description: '', feedUrl: '' });
  const [temp, setTemp] = useState({ title: '', description: '', feedUrl: '' });
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchRss = async () => {
      try {
        const response = await rssFeedService.get();
        if (response.data && response.data.id) {
          setRssId(response.data.id);
          setRss({
            title: response.data.title || '',
            description: response.data.description || '',
            feedUrl: response.data.feedUrl || '',
          });
        }
      } catch (err) {
        console.error('Error fetching RSS feed:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchRss();
  }, []);

  const handleLogout = () => {
    authService.logout();
    navigate('/admin-login');
  };

  const handleEdit = () => {
    setTemp({ ...rss });
    setEditing(true);
  };

  const handleSave = async () => {
    try {
      if (rssId) {
        await rssFeedService.update(rssId, temp);
      } else {
        const response = await rssFeedService.create(temp);
        setRssId(response.data.id);
      }
      setRss({ ...temp });
      setEditing(false);
      setError('');
    } catch (err) {
      setError('خطا در ذخیره RSS Feed');
    }
  };

  const handleCancel = () => {
    setTemp({ ...rss });
    setEditing(false);
  };

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  const fields = [
    { key: 'title', label: 'عنوان', rows: 2 },
    { key: 'description', label: 'توضیحات', rows: 6 },
    { key: 'feedUrl', label: 'آدرس فید', rows: 2 },
  ];

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h1 className="text-4xl font-bold mb-2">مدیریت RSS Feed</h1>
              <p className="text-xl text-blue-100">ویرایش محتوای صفحه RSS Feed</p>
            </div>
            <div className="flex gap-2">
              <button onClick={() => navigate('/admin/articles')} className="flex items-center gap-2 px-4 py-2 bg-blue-700 hover:bg-blue-600 rounded-lg font-semibold transition">
                <ArrowRight size={18} />
                بازگشت
              </button>
              <button onClick={handleLogout} className="flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg font-semibold transition">
                <LogOut size={18} />
                خروج
              </button>
            </div>
          </div>
        </div>
      </div>

      <AdminNav />

      <div className="max-w-7xl mx-auto px-4 py-12">
        {error && <div className="bg-red-50 text-red-700 p-4 rounded-lg mb-6">{error}</div>}

        <div className="bg-white rounded-xl shadow-md p-8">
          <div className="flex items-center gap-3 mb-6">
            <Rss className="text-blue-700" size={28} />
            <h2 className="text-3xl font-bold text-gray-900">تنظیمات RSS Feed</h2>
          </div>

          {editing ? (
            <div className="space-y-4">
              {fields.map(field => (
                <div key={field.key}>
                  <label className="block text-sm font-bold text-gray-900 mb-2">{field.label}</label>
                  <textarea
                    value={temp[field.key]}
                    onChange={e => setTemp({ ...temp, [field.key]: e.target.value })}
                    rows={field.rows}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                  />
                </div>
              ))}
              <div className="flex gap-4">
                <button onClick={handleSave} className="flex-1 px-6 py-3 bg-green-600 text-white rounded-lg font-bold hover:bg-green-700 transition">ذخیره</button>
                <button onClick={handleCancel} className="flex-1 px-6 py-3 bg-gray-300 text-gray-700 rounded-lg font-bold hover:bg-gray-400 transition">انصراف</button>
              </div>
            </div>
          ) : (
            <div>
              {fields.map(field => (
                <div key={field.key} className="mb-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{field.label}</h3>
                  <div className="text-gray-700 leading-relaxed whitespace-pre-wrap">
                    {rss[field.key] || 'اطلاعاتی برای نمایش وجود ندارد'}
                  </div>
                </div>
              ))}
              <button onClick={handleEdit} className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700 transition">
                <Edit2 size={18} />
                ویرایش
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminRSSFeed;
